import { Loader } from "@client/components/navbar/loader";
import { authClient } from "@client/lib/auth-client";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/(auth)")({
	component: Layout,
});

function Layout() {
	const { data: session, isPending } = authClient.useSession();
	const navigate = useNavigate();

	useEffect(() => {
		// Redirect logged-in users to dashboard
		if (!isPending && session?.user) {
			navigate({ to: "/dashboard" });
		}
	}, [session, isPending, navigate]);

	if (isPending) {
		return <Loader />;
	}

	// If user is logged in, show loader while redirecting
	if (session?.user) {
		return <Loader />;
	}

	return <Outlet />;
}
